export const NEW_INDEX_PATH = '/newIndex';

export function getAppRoot() {
  return document.getElementById('app');
}

export function getNewIndexScrollContainer() {
  const niPage = document.querySelector('.ni-page');
  if (niPage) {
    return niPage;
  }

  const app = getAppRoot();
  if (app && app.scrollHeight > app.clientHeight + 1) {
    return app;
  }

  return document.scrollingElement || document.documentElement;
}

export function getAppScrollTop() {
  const container = getNewIndexScrollContainer();

  if (
    container === document.documentElement
    || container === document.body
    || container === document.scrollingElement
  ) {
    return window.scrollY
      || document.documentElement.scrollTop
      || document.body.scrollTop
      || 0;
  }

  return container.scrollTop || 0;
}

function resetScrollElement(el, scrollBehavior) {
  if (!el) return;

  el.scrollTo({ top: 0, left: 0, behavior: scrollBehavior });
  el.scrollTop = 0;
  el.scrollLeft = 0;
}

export function scrollAppToTop(behavior = 'auto') {
  const scrollBehavior = behavior === 'instant' ? 'auto' : behavior;

  window.scrollTo({ top: 0, left: 0, behavior: scrollBehavior });

  resetScrollElement(document.scrollingElement, scrollBehavior);
  resetScrollElement(document.documentElement, scrollBehavior);
  resetScrollElement(document.body, scrollBehavior);
  resetScrollElement(getAppRoot(), scrollBehavior);

  document.querySelectorAll('.ni-page').forEach((el) => {
    resetScrollElement(el, scrollBehavior);
  });
}

export function scheduleScrollAppToTop(behavior = 'instant') {
  scrollAppToTop(behavior);
  requestAnimationFrame(() => scrollAppToTop(behavior));
  setTimeout(() => scrollAppToTop(behavior), 0);
  setTimeout(() => scrollAppToTop(behavior), 50);
  setTimeout(() => scrollAppToTop(behavior), 150);
  setTimeout(() => scrollAppToTop(behavior), 350);
}

export function getNewIndexHeaderOffset() {
  const header = document.querySelector('.ni-header');
  return header ? header.offsetHeight : 0;
}

export function scrollNewIndexToHash(hash, behavior = 'smooth') {
  if (!hash) return false;

  const href = hash.startsWith('#') ? hash : `#${hash}`;
  const container = getNewIndexScrollContainer();

  if (href === '#home') {
    container.scrollTo({ top: 0, behavior });
    return true;
  }

  const el = document.getElementById(href.replace('#', ''));
  if (!el) return false;

  const headerOffset = getNewIndexHeaderOffset();
  const containerRect = container.getBoundingClientRect();
  const elTop = el.getBoundingClientRect().top - containerRect.top + container.scrollTop;

  container.scrollTo({
    top: Math.max(0, elTop - headerOffset),
    behavior,
  });

  return true;
}
